export default "__VITE_ASSET__6adc0f83__"